import { render, staticRenderFns } from "./FormControlTypeDatetimeLocal.vue?vue&type=template&id=474e3f9a&scoped=true"
import script from "./FormControlTypeDatetimeLocal.vue?vue&type=script&lang=js"
export * from "./FormControlTypeDatetimeLocal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474e3f9a",
  null
  
)

export default component.exports